var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showPopup)?_c('div',{staticClass:"card popup-card"},[_c('div',{staticClass:"info"},[_vm._t("default")],2),_c('div',{staticClass:"popup-buttons"},[_vm._t("buttons")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }